import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import BannerBox from './bannerBox';

class Banner extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const {
            content: { content, bannerAd },
        } = this.props;

        return (
            <div id="banner" className={styles.banner}>
                <Chip
                    id="75024"
                    type="recommend"
                    title="推荐图"
                    groupName="推荐图栏"
                    translate="handleRecommendImageData"
                    content={content}>
                    <BannerBox ad={bannerAd} />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(Banner);
